export const designTemplateStyles = {
  container: {
    mb: {
      mobile: "6rem",
      tablet: "7.5rem",
      laptop: "10rem",
    },
    mx: {
      mobile: "auto",
    },
    display: {
      mobile: "flex",
    },
    alignItems: {
      laptop: "center",
    },
    justifyContent: {
      laptop: "space-between",
    },
    maxWidth: {
      mobile: "330px",
      tablet: "700px",
      laptop: "69.438rem",
    },
  },
};
